import { get } from 'lodash';
import React, { useCallback } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Price from '../../../../../frontend/components/components/utils/numbers/Price';
import ResponsiveHeader from '../../../../shared/components/ResponsiveHeader';
import useBreakpoint, { SIZE_XS } from '../../../../shared/hooks/useBreakpoint';
import CorgisTableOnSteroids from './CorgisTableOnSteroids.jsx';
import { Link } from "react-router-dom";

function LoyaltyProgram() {
  const user = useSelector(store => get(store, 'auth.user'));
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();

  const RewardsCard = useCallback(() => <Card className="grey4 border-0 mb-5 mb-sm-0">
    <Card.Body className='p-0 m-4 font-weight-normal'>
      <div>
        <h3>{user.corgi_count || 0}</h3>
        <div className="text-uppercase mb-3">
          {t('influencers.pages.profile.loyalty_program.corgis_collected')}
        </div>
      </div>
      <div>
        <h3>{user.unredeemed_corgi_count || 0} {t('influencers.common.of')} {user.corgi_redeem_bucket || 0}</h3>
        <div className="text-uppercase mb-3">
          {t('influencers.pages.profile.loyalty_program.to_next_reward')}
        </div>
      </div>
      <div>
        <h3>
          {user.corgi_earned_so_far || <Price number={0} currency={user.currency} />}
        </h3>
        <div className="text-uppercase">
          {t('influencers.pages.profile.loyalty_program.money_earned')}
        </div>
      </div>
    </Card.Body>
  </Card>, []);

  const isMobile = [SIZE_XS].includes(breakpoint);

  return (
    <React.Fragment>
      {isMobile && <RewardsCard />}
      <Container className='my-5 my-sm-6'>
        <Row>
          <Col xs={12} sm={6} md={8}>
            <ResponsiveHeader xs="h4" sm="h3" className='mb-3'>
              {t('influencers.pages.profile.loyalty_program.incentives')}
            </ResponsiveHeader>
            <div className="text-1 mb-3">
              {t('influencers.pages.profile.loyalty_program.incentives_desc')}
            </div>
            <div className="text-1 mb-6">
            <Trans i18nKey='influencers.pages.profile.loyalty_program.incentives_more_info'
              components={[<Link to="/learning-center"  target="_blank"/>,
              <a href="https://studioblog.obvious.ly/obviously-insightful/2018/2/26/how-we-work-corgi-rewards" target="_blank"/>]}>
            </Trans>
            </div>
            <ResponsiveHeader xs="h5" sm="h4" className='mb-4'>
              {t('influencers.pages.profile.loyalty_program.past_reward_history')}
            </ResponsiveHeader>
            <CorgisTableOnSteroids />
            <Row>
              <Col className="mb-5 mb-sm-3" xs={12} sm={6}>
                <h6 className='mb-3'>
                  {t('influencers.pages.profile.loyalty_program.about_corgi_rewards')}
                </h6>
                <div className="text-1">
                  {t('influencers.pages.profile.loyalty_program.rewards_desc')}
                  <ul className='mt-3'>
                    <li>{t('influencers.pages.profile.loyalty_program.rewards_desc_1')}</li>
                    <li>{t('influencers.pages.profile.loyalty_program.rewards_desc_2')}</li>
                    <li>{t('influencers.pages.profile.loyalty_program.rewards_desc_3')}</li>
                  </ul>
                </div>
              </Col>
              <Col className="mb-5 mb-sm-3" xs={12} sm={6}>
                <h6 className='mb-3'>
                  {t('influencers.common.details')}
                </h6>
                <div className="text-1">
                  {t('influencers.pages.profile.loyalty_program.details_desc', {
                    redemptionAmount: user.corgi_payment_per_redemption || '$100',
                    corgiRedeemBucket: user.corgi_redeem_bucket || 10
                  })}
                </div>
              </Col>
              <Col className="mb-5 mb-sm-3" xs={12}>
                <h6 className='mb-3'>
                  {t('influencers.common.caveats')}
                </h6>
                <div className="text-1">
                  {t('influencers.pages.profile.loyalty_program.caveats_desc')}
                </div>
              </Col>
            </Row>
          </Col>
          {!isMobile &&
            <Col xs={12}
              sm={6}
              md={{
                offset: 1,
                span: 3
              }}>
              <RewardsCard />
            </Col>
          }
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default React.memo(LoyaltyProgram);
